import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 17l5-5-5-5v10z"
}), 'ArrowRightOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowRightOutlined.js
// module id = 2119
// module chunks = 2